export const ID_MESSAGE = `Your driver will need to see photo ID!`;